<div class="container-fluid theme-wrapper blog-section">
  <div class="container my-5">
    <div class="row" *ngIf="highlightData?.results?.length">
      <div class="col-md-7" *ngIf="highlightData.results[0] as featured">
        <img [src]="featured.uri?.trim()" alt="{{ featured.title }}" class="blog-image" />
        <div class="blog-title">{{ featured.title }}</div>
        <div class="blog-date">
          <ng-container
            *ngIf="
              !featured.updated ||
                (parseDate(featured.created) | date: 'yyyy-MM-dd') ===
                  (parseDate(featured.updated) | date: 'yyyy-MM-dd');
              else showUpdatedDate
            "
          >
            {{ parseDate(featured.created) | date: 'dd MMMM yyyy' | uppercase }}
          </ng-container>
          <ng-template #showUpdatedDate>
            {{ parseDate(featured.updated) | date: 'dd MMMM yyyy' | uppercase }}
          </ng-template>
        </div>
        <p class="blog-description">
          {{ stripHtmlAndLimitChars(featured.body, 160) }}
        </p>
        <a href="#" (click)="itemClick(featured); $event.preventDefault()" class="read-more">
          {{ 'Read More' | translate }} <span class="arrow">➞</span>
        </a>
      </div>

      <div class="col-md-5">
        <div
          class="media mb-4"
          *ngFor="let blog of highlightData.results.slice(1, 4)"
          (click)="itemClick(blog)"
          style="cursor: pointer"
        >
          <img [src]="blog.uri?.trim()" class="mr-3 rounded" alt="{{ blog.title }}" />
          <div class="media-body">
            <div class="blog-title">{{ blog.title }}</div>
            <div class="blog-date">
              {{ parseDate(blog.updated) | date: 'dd MMMM yyyy' | uppercase }}
            </div>
            <p class="blog-description">
              {{ stripHtmlAndLimitChars(blog.body, 80) }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <a routerLink="/blog" class="see-all"> {{ 'See All Blogs' | translate }} <span class="arrow">➞</span> </a>
  </div>
</div>
